<table
  mat-table
  class="mat-table"
  [dataSource]="dataSource"
  *ngIf="data.rows.length > 0; else noDataTemplate"
>
  <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.key">
    <th mat-header-cell *matHeaderCellDef [ngClass]="getColumnClass(column)">
      <span overflowTooltip class="drilldown-table-overflow-label">{{ column.label }}</span>
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="getColumnClass(column)">
      <ng-container *ngIf="column.isBadge; else defaultCell">
        <status-badge
          [type]="'studyMilestoneStatus'"
          [badgeKey]="element[column.key]"
          [showLabel]="size === 'large'"
        >
        </status-badge>
      </ng-container>
      <ng-template #defaultCell>
        <span overflowTooltip class="drilldown-table-overflow-label">{{
          formatLabel(column, element[column.key])
        }}</span>
      </ng-template>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumnsKeys"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumnsKeys"></tr>
</table>

<ng-template #noDataTemplate>
  <drilldown-chart-no-data-available [size]="size"></drilldown-chart-no-data-available>
</ng-template>
